<template>
    <div v-if="paymentMethods" class="ManageCreditCards">
        <div v-for="paymentMethod in paymentMethods" class="card">
            <div class="cardMain">
                <h4>{{ paymentMethod.billing_details.name }} xxxx-{{ paymentMethod.card.last4 }}</h4>
                <span>
                    Expires {{ paymentMethod.card.exp_month }}/{{ paymentMethod.card.exp_year }} &bull; Added on {{ paymentMethod.created | formatDate }}
                </span>
            </div>

            <div class="cardAside">
                <div v-if="paymentMethod.default" class="tag">DEFAULT</div>

                <CreditCardIcon :brand="paymentMethod.card.brand"/>
                <Dropdown v-if="!paymentMethod.default">
                    <template #trigger>
                        <Icon name="ellipsis-v"/>
                    </template>
                    <template #menu>
                        <Button v-if="!paymentMethod.default" @click="handleDefaultPaymentMethod(paymentMethod)">Set Default</Button>
                        <Button v-if="!paymentMethod.default" class="danger" @click="handleRemovePaymentMethod(paymentMethod)">Delete</Button>
                    </template>
                </Dropdown>
            </div>
        </div>
        <div class="actions">
            <Button class="outline" @click="handleAddCard">Add Credit Card</Button>
        </div>
    </div>
</template>


<script>
import * as api from '@/api';
import AddCardModal from '@/components/modals/AddCardModal';
import Dropdown from '@/components/Dropdown';
import CreditCardIcon from './CreditCardIcon';

export default {
    name: 'ManageCreditCards',

    components: { AddCardModal, Dropdown, CreditCardIcon },

    data: () => ({
        paymentMethods: [],
        submitStatus: '',
    }),

    mounted() {
        this.fetchPaymentMethod();
    },

    methods: {
        async fetchPaymentMethod() {
            const res = await api.getPaymentMethods();
            if (!res.ok) {
                return this.$awn.alert('Failed to fetch payment methods');
            }

            this.paymentMethods = res.body;
        },

        async handleDefaultPaymentMethod(paymentMethod) {
            const res = await api.setDefaultPaymentMethod(paymentMethod.id);
            if (!res.ok) {
                return this.$awn.alert('Failed to set default payment method');
            }

            this.fetchPaymentMethod();
        },

        async handleRemovePaymentMethod(paymentMethod) {
            const res = await api.removePaymentMethod(paymentMethod.id);
            if (!res.ok) {
                return this.$awn.alert('Failed to remove payment method');
            }

            this.fetchPaymentMethod();
        },

        handleAddCard() {
            this.$modal.show(AddCardModal, {}, { height: 'auto' }, { closed: this.fetchPaymentMethod });
        },
    }
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.ManageCreditCards {
    .card {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: $border-radius;
        border: 1px solid $divider-color;
        padding: 10px $grid-gutter-width;

        .cardAside {
            display: flex;
            align-items: center;
            line-height: 1;

            h4 {
                color: $text-color-muted;
                text-transform: uppercase;
            }

            .cardActions {
                display: flex;
                align-items: center;
            }

            .CreditCardIcon {
                font-size: 28px;
            }
        }

        .tag {
            padding: 5px;
            margin-right: 5px;
            border-radius: $border-radius;
            background-color: $bg-color-4;
            font-size: 12px;
            font-weight: $font-weight-bold;
            color: rgba($text-color-primary, 0.8);
        }

        .Dropdown {
            margin-left: $grid-gutter-width;
            color: $text-color-muted;

            ::v-deep .Button {
                line-height: 1;
            }
        }
    }

    .card + .card {
        border-top: none;
    }

    .actions {
        .Button {
            display: block;
            margin-top: $grid-gutter-width;
            margin-left: auto;
        }
    }
}
</style>
